import { useEffect } from 'react';

import styles from './VATReturns.module.css';
import { useGetDocuments } from '../../../../api/lendingApi/lendingApiQueries';
import { useDocumentUploadMutation } from '../../../../api/lendingApi/useDocumentUploadMutation';
import { useContextStateKey } from '../../../../hooks/useContextStateKey';
import { useFileUploadReducer } from '../../../../hooks/useFileUploadReducer';
import DragDropUpload from '../components/DragDropUpload/DragDropUpload';
import FileStatusSections from '../components/FileStatusSections/FileStatusSections';

const DOCUMENT_TYPE = 'vat return';

const listOfInstructions = [
  'We accept PDF or JPG, JPEG, PNG statements downloaded from either the HMRC portal or from your accounting software',
  <>
    Need help? Check out our VAT return guide{' '}
    <a
      href="https://static.iwoca.com/pdf/vat_return_instructions.pdf"
      target="_blank"
      rel="noreferrer"
    >
      here
    </a>
  </>,
];
const VATReturns = () => {
  const stateKey = useContextStateKey();

  const {
    uploadedFiles,
    setAllFiles,
    setFileLoading,
    setFileSuccess,
    setFileError,
    setFileReject,
    removeFile,
  } = useFileUploadReducer();

  const { documents } = useGetDocuments(stateKey);

  const mutation = useDocumentUploadMutation();

  const handleUpload = (stateKey: string, body: FormData) => {
    return mutation.mutateAsync({ stateKey, body });
  };

  useEffect(() => {
    if (documents) {
      const VATreturnsDocuments = documents.data.filter(
        (document) => document.attributes.document_type === DOCUMENT_TYPE,
      );
      setAllFiles(VATreturnsDocuments);
    }
  }, [documents]);

  return (
    <div className={styles.container}>
      <DragDropUpload
        documentType={DOCUMENT_TYPE}
        listOfInstructions={listOfInstructions}
        onUpload={handleUpload}
        setFileLoading={setFileLoading}
        setFileSuccess={setFileSuccess}
        setFileError={setFileError}
        setFileReject={setFileReject}
      />
      <FileStatusSections files={uploadedFiles} removeFile={removeFile} />
    </div>
  );
};

export default VATReturns;
